const configuration = {
  googleAnalyticsCode: "UA-143469574-2"
}

export default configuration;


// WEBPACK FOOTER //
// ./src/config/config.js